import { render, staticRenderFns } from "./AssistanceList.vue?vue&type=template&id=48c65293&scoped=true&"
import script from "./AssistanceList.vue?vue&type=script&lang=js&"
export * from "./AssistanceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c65293",
  null
  
)

export default component.exports